import { TComponentType } from '../AppPage2/types'

export function getSheetContentLayout(contentType: TComponentType): {
  side?: 'top' | 'bottom' | 'left' | 'right'
  className: string
} {
  if (contentType === 'data-table-v2') {
    return {
      side: 'bottom',
      className: '!pointer-events-auto flex h-[70vh] max-h-[70vh] w-full flex-col p-6',
    }
  }

  return {
    className: '!pointer-events-auto pr-0 lg:max-w-3xl',
  }
}
